import React, {useState} from "react";
import { useNavigate } from "react-router-dom";

const AllTickets = [
  {
    id: "#12345",
    category: "Ticket Category 1",
    description: "Lorem ipsum dolor sit amet...",
    created: "20/02/2024",
    status: "Solved",
  },
  {
    id: "#12345",
    category: "Ticket Category 2",
    description: "Lorem ipsum dolor sit amet...",
    created: "20/02/2024",
    status: "Pending",
  },
  {
    id: "#12345",
    category: "Ticket Category 3",
    description: "Lorem ipsum dolor sit amet...",
    created: "20/02/2024",
    status: "Solved",
  },
  {
    id: "#12345",
    category: "Ticket Category 4",
    description: "Lorem ipsum dolor sit amet...",
    created: "20/02/2024",
    status: "Pending",
  },
  {
    id: "#12345",
    category: "Ticket Category 5",
    description: "Lorem ipsum dolor sit amet...",
    created: "20/02/2024",
    status: "Solved",
  },
];

const SupportTickets = () => {
  const navigate = useNavigate();

  const [ticketDetails, setTicketDetails] = useState(null); // Track which detail's popup is open


 const handleTicketDetails = (index) => {
    setTicketDetails(ticketDetails === index ? null : index); // Toggle the popup for the clicked ticket Details
  };

  return (
    <>
      <div className="w-[1014px] h-[590px] bg-[#FFF9F2] rounded-r-[10px] flex flex-col pt-[30px] pb-[20px] px-[32px]">
        <div className="w-full flex flex-row items-center justify-between">
          <h2 className="w-[142px] h-[27px] text-black font-semibold text-[18px]">
            Support Tickets
          </h2>
          <button
            className="w-[155px] h-[42px] rounded-[5px] bg-[#FF6300] font-semibold text-[14px] text-white"
            onClick={() => navigate(`/orders/ticketList/newTicket/${"789"}`)}
          >
            Raise New Ticket
          </button>
        </div>

        <hr className="w-[206px] h-[3px] bg-[#FF6300] mt-[6px] rounded-full" />
        <div className="w-full flex flex-row items-center justify-between mt-[15px]">
          <div className="w-[305px] h-[96px] bg-white rounded-[10px] py-[19px] pr-[15px] flex drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
            <hr className="w-[9px] h-[57px] bg-[#85B6FF] rounded-r-[7px]" />
            <div className="w-[214px] h-full flex flex-col items-start pl-[19px] justify-between">
              <h4 className="w-[102px] h-[18px] font-semibold text-[14px] text-start text-black">
                Tickets Raised
              </h4>
              <p className="w-[21px] h-[25px] font-semibold text-[20px] text-[#FF6300] text-start">
                5
              </p>
            </div>
            <div className="w-[65px] h-full flex items-center justify-center">
              <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_608_11595)">
                  <path
                    d="M30 10V14"
                    stroke="#D9D9D9"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M30 22V26"
                    stroke="#D9D9D9"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M30 34V38"
                    stroke="#D9D9D9"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10 10H38C39.0609 10 40.0783 10.4214 40.8284 11.1716C41.5786 11.9217 42 12.9391 42 14V20C40.9391 20 39.9217 20.4214 39.1716 21.1716C38.4214 21.9217 38 22.9391 38 24C38 25.0609 38.4214 26.0783 39.1716 26.8284C39.9217 27.5786 40.9391 28 42 28V34C42 35.0609 41.5786 36.0783 40.8284 36.8284C40.0783 37.5786 39.0609 38 38 38H10C8.93913 38 7.92172 37.5786 7.17157 36.8284C6.42143 36.0783 6 35.0609 6 34V28C7.06087 28 8.07828 27.5786 8.82843 26.8284C9.57857 26.0783 10 25.0609 10 24C10 22.9391 9.57857 21.9217 8.82843 21.1716C8.07828 20.4214 7.06087 20 6 20V14C6 12.9391 6.42143 11.9217 7.17157 11.1716C7.92172 10.4214 8.93913 10 10 10Z"
                    stroke="#D9D9D9"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_608_11595">
                    <rect width="48" height="48" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>

          <div className="w-[305px] h-[96px] bg-white rounded-[10px] py-[19px] pr-[15px] flex drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
            <hr className="w-[9px] h-[57px] bg-[#6FC33B] rounded-r-[7px]" />
            <div className="w-[214px] h-full flex flex-col items-start pl-[19px] justify-between">
              <h4 className="w-[119px] h-[18px] font-semibold text-[14px] text-start text-black">
                Tickets Solved
              </h4>
              <p className="w-[21px] h-[25px] font-semibold text-[20px] text-[#FF6300] text-start">
                3
              </p>
            </div>
            <div className="w-[65px] h-full flex items-center justify-center">
              <svg
                width="51"
                height="51"
                viewBox="0 0 51 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.125 25.5L23.375 29.75L31.875 21.25M6.375 25.5C6.375 28.0115 6.86968 30.4985 7.8308 32.8188C8.79192 35.1392 10.2007 37.2475 11.9766 39.0234C13.7525 40.7993 15.8608 42.2081 18.1812 43.1692C20.5015 44.1303 22.9885 44.625 25.5 44.625C28.0115 44.625 30.4985 44.1303 32.8188 43.1692C35.1392 42.2081 37.2475 40.7993 39.0234 39.0234C40.7993 37.2475 42.2081 35.1392 43.1692 32.8188C44.1303 30.4985 44.625 28.0115 44.625 25.5C44.625 22.9885 44.1303 20.5015 43.1692 18.1812C42.2081 15.8608 40.7993 13.7525 39.0234 11.9766C37.2475 10.2007 35.1392 8.79193 32.8188 7.8308C30.4985 6.86968 28.0115 6.375 25.5 6.375C22.9885 6.375 20.5015 6.86968 18.1812 7.8308C15.8608 8.79193 13.7525 10.2007 11.9766 11.9766C10.2007 13.7525 8.79192 15.8608 7.8308 18.1812C6.86968 20.5015 6.375 22.9885 6.375 25.5Z"
                  stroke="#D9D9D9"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>

          <div className="w-[305px] h-[96px] bg-white rounded-[10px] py-[19px] pr-[15px] flex drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
            <hr className="w-[9px] h-[57px] bg-[#FF6300] rounded-r-[7px]" />
            <div className="w-[214px] h-full flex flex-col items-start pl-[19px] justify-between">
              <h4 className="w-[113px] h-[18px] font-semibold text-[14px] text-start text-black">
                Tickets Pending
              </h4>
              <p className="w-[21px] h-[25px] font-semibold text-[20px] text-[#FF6300] text-start">
                2
              </p>
            </div>
            <div className="w-[65px] h-full flex items-center justify-center">
              <svg
                width="42"
                height="42"
                viewBox="0 0 42 42"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_608_11601)">
                  <path
                    d="M33.25 9.261V3.5H35C35.4641 3.5 35.9093 3.31563 36.2374 2.98744C36.5656 2.65925 36.75 2.21413 36.75 1.75C36.75 1.28587 36.5656 0.840752 36.2374 0.512563C35.9093 0.184374 35.4641 0 35 0L7 0C6.53587 0 6.09075 0.184374 5.76256 0.512563C5.43437 0.840752 5.25 1.28587 5.25 1.75C5.25 2.21413 5.43437 2.65925 5.76256 2.98744C6.09075 3.31563 6.53587 3.5 7 3.5H8.75V9.261C8.74259 11.5376 9.37314 13.7708 10.5702 15.7074C11.7672 17.644 13.4828 19.2065 15.5225 20.2178L17.087 21L15.5225 21.7822C13.4828 22.7935 11.7672 24.356 10.5702 26.2926C9.37314 28.2292 8.74259 30.4624 8.75 32.739V38.5H7C6.53587 38.5 6.09075 38.6844 5.76256 39.0126C5.43437 39.3408 5.25 39.7859 5.25 40.25C5.25 40.7141 5.43437 41.1592 5.76256 41.4874C6.09075 41.8156 6.53587 42 7 42H35C35.4641 42 35.9093 41.8156 36.2374 41.4874C36.5656 41.1592 36.75 40.7141 36.75 40.25C36.75 39.7859 36.5656 39.3408 36.2374 39.0126C35.9093 38.6844 35.4641 38.5 35 38.5H33.25V32.739C33.2574 30.4624 32.6269 28.2292 31.4298 26.2926C30.2328 24.356 28.5172 22.7935 26.4775 21.7822L24.913 21L26.4775 20.2178C28.5172 19.2065 30.2328 17.644 31.4298 15.7074C32.6269 13.7708 33.2574 11.5376 33.25 9.261ZM12.25 9.261V3.5H29.75V9.261C29.7556 10.8871 29.3054 12.4823 28.4505 13.8656C27.5955 15.2489 26.37 16.3649 24.913 17.087L21 19.0435L17.087 17.087C15.63 16.3649 14.4045 15.2489 13.5495 13.8656C12.6946 12.4823 12.2444 10.8871 12.25 9.261ZM29.75 32.739V38.5H12.25V32.739C12.2444 31.1129 12.6946 29.5177 13.5495 28.1344C14.4045 26.7511 15.63 25.6351 17.087 24.913L21 22.9565L24.913 24.913C26.37 25.6351 27.5955 26.7511 28.4505 28.1344C29.3054 29.5177 29.7556 31.1129 29.75 32.739Z"
                    fill="#D9D9D9"
                  />
                  <path
                    d="M18.6532 13.956C19.0679 14.1592 19.5461 14.1902 19.9835 14.0424C20.421 13.8946 20.7823 13.5799 20.9887 13.1668C21.1951 12.7537 21.2299 12.2758 21.0855 11.8372C20.9411 11.3986 20.6292 11.0349 20.2177 10.8252C19.9263 10.681 19.6812 10.4579 19.5101 10.1814C19.3391 9.90485 19.249 9.58591 19.25 9.26074C19.25 8.79661 19.0656 8.35149 18.7374 8.02331C18.4092 7.69512 17.9641 7.51074 17.5 7.51074C17.0359 7.51074 16.5907 7.69512 16.2626 8.02331C15.9344 8.35149 15.75 8.79661 15.75 9.26074C15.747 10.2364 16.0173 11.1935 16.5305 12.0234C17.0436 12.8532 17.779 13.5227 18.6532 13.956ZM23.3467 28.0435C22.9321 27.8403 22.4539 27.8092 22.0165 27.9571C21.579 28.1049 21.2177 28.4196 21.0113 28.8327C20.8049 29.2458 20.7701 29.7237 20.9145 30.1623C21.0589 30.6009 21.3708 30.9646 21.7822 31.1742C22.0737 31.3185 22.3188 31.5416 22.4899 31.8181C22.6609 32.0946 22.751 32.4136 22.75 32.7387C22.75 33.2029 22.9344 33.648 23.2626 33.9762C23.5907 34.3044 24.0359 34.4887 24.5 34.4887C24.9641 34.4887 25.4092 34.3044 25.7374 33.9762C26.0656 33.648 26.25 33.2029 26.25 32.7387C26.253 31.763 25.9827 30.806 25.4695 29.9761C24.9564 29.1462 24.221 28.4767 23.3467 28.0435Z"
                    fill="#D9D9D9"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_608_11601">
                    <rect width="42" height="42" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </div>

        <h3 className="w-[82px] h-[24px] font-semibold text-[16px] text-start text-black mt-[20px]">
          All Tickets
        </h3>

        <div className="mt-[14px]">
          <table className="table w-full drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] rounded-[10px] overflow-hidden bg-white">
            <thead>
              <tr className="text-center bg-[#FEECD4] text-black font-semibold text-[14px] h-[60px] py-[23px] pl-[15px]">
                <th className="w-[48px] h-[21px]">Ticket ID</th>
                <th className="w-[40px] h-[21px]">Ticket Category</th>
                <th className="w-[130px] h-[21px]">Description</th>
                <th className="w-[20px] h-[21px]">Created On</th>
                <th className="w-[20px] h-[21px]">Status</th>
                <th className="w-[50px] h-[42px]">Action</th>
              </tr>
            </thead>
            <tbody className="text-center font-medium text-[12px] [&>*:nth-child(even)]:bg-[#F8F8F8] [&>*:nth-child(odd)]:bg-white">
              {AllTickets.map((item) => (
                <tr key={item.srNo} className="hover:bg-gray-100 h-[52px]">
                  <td className="">{item.id}</td>
                  <td className="">{item.category}</td>
                  <td className="">
                    {/* {item.img} */}
                    {item.description}
                  </td>
                  <td className="">{item.created}</td>
                  <td className="">{item.status}</td>
                  <td className="">
                    <button
                      className="text-[#FF6300] font-medium text-[12px]"
                      onClick={() =>
                        navigate(`/orders/ticketList/viewTickets/${"321"}`)
                      }
                    >
                      View Details
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default SupportTickets;
